export { default as SerpApStockTransferSlot } from './SerpApStockTransferSlot';
